var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassdoorReviewsSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aaced7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25529,
    stopColor: "#59bb8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#0daa41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d775f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.88544,28.84344h-2.79095c-.13593-1.38416-1.28961-2.46967-2.70953-2.46967h-12.77026c-1.41986,0-2.57361,1.08551-2.70953,2.46967h-2.7912c-3.96002,0-7.18121,3.2218-7.18121,7.18121v30.42029c0,3.95941,3.22119,7.18121,7.18121,7.18121h23.77148c3.96002,0,7.18182-3.2218,7.18182-7.18121v-30.42029c0-3.95941-3.2218-7.18121-7.18182-7.18121ZM65.41235,66.44495c0,1.94403-1.58234,3.52637-3.52692,3.52637h-23.77148c-1.94458,0-3.52631-1.58234-3.52631-3.52637v-30.42029c0-1.94397,1.58173-3.52637,3.52631-3.52637h2.79126c.13635,1.38391,1.28986,2.46899,2.70947,2.46899h12.77026c1.41968,0,2.57312-1.08508,2.70941-2.46899h2.79108c1.94458,0,3.52692,1.5824,3.52692,3.52637v30.42029Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.17822,41.57599h-14.35645c-1.00952,0-1.82745.81854-1.82745,1.82739,0,1.00891.81793,1.82745,1.82745,1.82745h14.35645c1.00952,0,1.82745-.81854,1.82745-1.82745,0-1.00885-.81793-1.82739-1.82745-1.82739Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.17822,58.44757h-14.35645c-1.00952,0-1.82745.81854-1.82745,1.82745,0,1.00885.81793,1.82739,1.82745,1.82739h14.35645c1.00952,0,1.82745-.81854,1.82745-1.82739,0-1.00891-.81793-1.82745-1.82745-1.82745Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.17822,50.01239h-14.35645c-1.00952,0-1.82745.81848-1.82745,1.82739s.81793,1.82745,1.82745,1.82745h14.35645c1.00952,0,1.82745-.81854,1.82745-1.82745s-.81793-1.82739-1.82745-1.82739Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassdoorReviewsSummary);
export default __webpack_public_path__ + "static/media/glassdoor-reviews-summary.80f29b2335def70c4ff38085eee92e12.svg";
export { ForwardRef as ReactComponent };